export default __webpack_public_path__ + "static/media/activeArrowLeftLight.fb1ae337.svg";